var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.59277C0 4.17449 3.58172 0.592773 8 0.592773H16C20.4183 0.592773 24 4.1745 24 8.59277V16.5928C24 21.0111 20.4183 24.5928 16 24.5928H8C3.58172 24.5928 0 21.0111 0 16.5928V8.59277Z",
    fill: "#876AFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6515 20.9982C20.2043 20.8829 20.5336 20.3045 20.2589 19.8111C19.6533 18.7234 18.6993 17.7677 17.4788 17.0393C15.907 16.1012 13.9812 15.5928 12 15.5928C10.0188 15.5928 8.09292 16.1012 6.52112 17.0393C5.30069 17.7677 4.34666 18.7234 3.74108 19.8111C3.46638 20.3045 3.79562 20.8829 4.34843 20.9982C9.39524 22.0499 14.6047 22.0499 19.6515 20.9982Z",
    fill: "#F8F8F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.59277,
    r: 5,
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f02ecf644c1dd479cf66841757971a86.svg";
export { ForwardRef as ReactComponent };